export enum UserTypeEnum {
  normal = 0,
  superAdmin = 1,
  partner = 2,
  chain = 3,
  store = 4,
  staff = 5,
  anonymous = 6,
}
